import { Link } from "react-router-dom";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Cargar from "../Pagos/Carga";
import OperacionesReporte from "./OperacionesReporte";
import SaldosReporte from "./SaldosReporte";
import Notificaciones from "./Notificaciones";
import Cuotas from "./Cuotas";
import "../Pagos/menuPagos.css";
import { useStore } from "../../app/stores/store";
import OperacionesR from "./OperacionesR";
import Exoneraciones from "./Exoneraciones";
import CargaInscripcion from "./CargaInscripcion";
import React from "react";
import ReporteInscritos from "../Informes/ReporteInscritos";
import ReporteBanrural from "../Informes/ReporteBanrural";

import ListaConvenios from "../Convenios/ListaConvenios";
import CreateConvenios from "../Convenios/CreateConvenios";

function MenuPagos() {
  
  const {
    userStore: { user, logout, isLoggedIn, roles },
    modalStore,
  } = useStore();

  const CargaP = () => (
    <div>
      <Cargar />
    </div>
  );

  const operacionM = () => (
    <div>
      <OperacionesReporte />
    </div>
  );

  const ReporteO = () => (
    <div>
      <OperacionesR />
    </div>
  );

  const ReporteS = () => (
    <div>
      <SaldosReporte />
    </div>
  );

  const NotificacionesR = () => (
    <div>
      <Notificaciones />
    </div>
  );

  const Cuotass = () => (
    <div>
      <Cuotas />
    </div>
  );

  const Exoneracioness = () => (
    <div>
      <Exoneraciones />
    </div>
  );

  const CargaI = () => (
    <div>
      <CargaInscripcion />
    </div>
  );

  const listadoConvenios = () => (
    <div>
      <ListaConvenios />
    </div>
  );

  const CrearConvenios = () => (
    <div>
      <CreateConvenios />
    </div>
  );

  const ReporteInscritosP = () => (
    <div>
      <ReporteInscritos />
    </div>
  );
  
  const ReporteBanruralP = () => (
    <div>
      <ReporteBanrural />
    </div>
  );

  return (
    <div className="conter">
      <div className="links">
        {roles()?.map((rol: any) => {
          if (rol == "Cargo Pagos") {
            return (
              <>
                <Link to="/cargapagos/:id">
                  <button className="link">Carga de Pagos</button>
                </Link>
              </>
            );
          }
          if (rol == "Reporte Inscritos") {
            return (
              <>
                <Link to="/cargapagos/:id/ReporteInscritosP">
                  <button className="link">Reporte Inscritos</button>
                </Link>
              </>
            );
          }
          if (rol == "Reporte Pagos") {
            return (
              <>
                <Link to="/cargapagos/:id/ReporteBanruralP">
                  <button className="link">Reporte Pagos</button>
                </Link>
              </>
            );
          }
          if (rol == "Exoneracions") {
            return (
              <Link to="/cargapagos/:id/Exoneracioness">
                <button className="link">Solicitud de Exoneraciones</button>
              </Link>
            );
          }
          if (rol == "Reporte movimientos") {
            return (
              <Link to="/cargapagos/:id/ReporteO">
                <button className="link">Reporte de Operaciones</button>
              </Link>
            );
          }
          if (rol == "Modificar Operaciones") {
            return (
              <Link to="/cargapagos/:id/operacionM">
                <button className="link">Modificación de Operaciones</button>
              </Link>
            );
          }
          if (rol == "Reporte saldos") {
            return (
              <Link to="/cargapagos/:id/ReporteS">
                <button className="link">Reporte de Saldos</button>
              </Link>
            );
          }
          if (rol == "Notificaciones") {
            return (
              <Link to="/cargapagos/:id/NotificacionesR">
                <button className="link">Notificaciones</button>
              </Link>
            );
          }
          if (rol == "Cuotas") {
            return (
              <Link to="/cargapagos/:id/Cuotass">
                <button className="link">Cuotas</button>
              </Link>
            );
          }
          if (rol == "Carga Inscritos") {
            return (
              <Link to="/cargapagos/:id/CargaI">
                <button className="link">
                  Carga de inscripcion institucional
                </button>
              </Link>
            );
          }

          // if (rol == "Crear Convenio") {
          //   return (

          //     <Link to="/cargapagos/:id/CrearConvenios">
          //       <button className="link">Crear Convenios</button>
          //     </Link>

          //   );
          // }

          if (rol == "Crear Convenio") {
            return (

              // <Link to="/cargapagos/:id/lista-convenios">
              <Link to="/convenios-panel">
                <button className="link">Códigos Institucionales</button>
              </Link>

            );
          }
        })}
      </div>

      <div className="tabs">
        <Switch>
          {roles()?.map((rol: any) => {
            if (rol == "Cargo Pagos") {
              return <Route path="/cargapagos/:id" 
              exact 
              component={CargaP} />;
            }
            if (rol == "Exoneracions") {
              return (
                <Route
                  path="/cargapagos/:id/Exoneracioness"
                  exact
                  component={Exoneracioness}
                />
              );
            }
            if (rol == "Reporte movimientos") {
              return (
                <Route
                  path="/cargapagos/:id/ReporteO"
                  exact
                  component={ReporteO}
                />
              );
            }
            if (rol == "Modificar Operaciones") {
              return (
                <Route
                  path="/cargapagos/:id/operacionM"
                  exact
                  component={operacionM}
                />
              );
            }
            if (rol == "Reporte saldos") {
              return (
                <Route
                  path="/cargapagos/:id/ReporteS"
                  exact
                  component={ReporteS}
                />
              );
            }
            if (rol == "Notificaciones") {
              return (
                <Route
                  path="/cargapagos/:id/NotificacionesR"
                  exact
                  component={NotificacionesR}
                />
              );
            }
            if (rol == "Cuotas") {
              return (
                <Route
                  path="/cargapagos/:id/Cuotass"
                  exact
                  component={Cuotass}
                />
              );
            }
            if (rol == "Carga Inscritos") {
              return (
                <Route path="/cargapagos/:id/CargaI" 
                exact 
                component={CargaI} />
              );
            }

            if (rol == "Crear Convenio") {
              return (
                <Route path="/cargapagos/:id/lista-convenios" 
                exact 
                component={listadoConvenios} />
              );
            }
            
            if (rol == "Crear Convenio") {
              return (
                <Route path="/cargapagos/:id/CreateConvenios" 
                exact 
                component={ CrearConvenios } />
              );
            }

            if (rol == "Reporte Inscritos") {
              return (
                <Route
                  path="/cargapagos/:id/ReporteInscritosP"
                  exact
                  component={ReporteInscritosP}
                />
              );
            }
            if (rol == "Reporte Inscritos") {
              return (
                <Route
                  path="/cargapagos/:id/ReporteBanruralP"
                  exact
                  component={ReporteBanruralP}
                />
              );
            }
          })}
        </Switch>
      </div>
    </div>
  );
}
export default MenuPagos;
